import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../../theme'
import RichText from '../../RichText'

export const Container = styled.div`
  padding: ${pxToRem(24)};
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  @media ${mq(sizes.desktop)} {
    flex-flow: row nowrap;
    padding: ${pxToRem(40)};
  }
`
export const Title = styled.dt`
  ${({ theme }) => theme.textStyles.m375_h2}
  @media ${mq(sizes.desktop)} {
    flex: 1 1 0;
  }
`
export const _RichText = styled(RichText)`
  ${({ theme }) => theme.textStyles.m375_body}
  margin: unset;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_body}
    flex: 1 1 0;
  }
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.d1440_body}
  @media ${mq(sizes.tablet)} {
  }
`
